import $ from "jquery";

// Bootstrap Collapse drives show/hide of the overflow <tbody>. This only syncs
// the toggle label and the fade overlay (is-collapsed) with Bootstrap events.

const wrapperSelector = ".collapsed-rows-table";

const syncToggle = function ($wrapper, expanded) {
  const $toggle = $wrapper.find("a.collapsed-rows-toggle").first();
  if (!$toggle.length) {
    return;
  }

  if (expanded) {
    $wrapper.removeClass("is-collapsed");
    $toggle.attr("aria-expanded", "true");
    $toggle.text($toggle.data("labelLess") || "SHOW LESS ‹");
  } else {
    $wrapper.addClass("is-collapsed");
    $toggle.attr("aria-expanded", "false");
    $toggle.text($toggle.data("labelMore") || "SHOW ALL ›");
  }
};

$(document).on("show.bs.collapse", `${wrapperSelector} tbody.collapsed-rows-overflow`, function () {
  syncToggle($(this).closest(wrapperSelector), true);
});

$(document).on("hide.bs.collapse", `${wrapperSelector} tbody.collapsed-rows-overflow`, function () {
  syncToggle($(this).closest(wrapperSelector), false);
});
